const generateRandomHexColor = (): string => {
  const letters = '0123456789ABCDEF';
  let color = '#';
  for (let i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)];
  }
  return color;
};

const anatomyColorMap: { [key: string]: string } = {
  'Aortic Arch': '#330000',
  'Aortic Root': '#003333',
  Pericardium: '#330033',
  'Aortic Valve Area': '#003300',
  'Inferior Vena Cava': '#331900',
  'Ascending Aorta Area': '#003333',
  'Intraventricular Septum': '#190033',
  'Sinotubular Junction to Ascending Aorta': '#332600',
  'LVOT Area': '#003319',
  'Aorta Annulus to Sinotubular Junction': '#330000',
  'Tricuspid Valve': '#001933',
  'Mitral Valve': '#193300',
  'Right Atrium': '#330019',
  'Left Ventricle': '#003319',
  'Left Atrium': '#260033',
  'Wave Form': '#332600',
  'Right Ventricle': '#003300',
  'Left Atrial Appendage': '#330000',
  'Left Pulmonary Veins': '#001933',
  'Right Pulmonary Veins': '#193300',
  'Left Superior Pulmonary Vein': '#330019',
  'Left Inferior Pulmonary Vein': '#003319',
  'Right Superior Pulmonary Vein': '#260033',
  'Right Inferior Pulmonary Vein': '#332600',
  'Coronary Cusps': '#003319',
  'Papillary Muscles': '#330019',
  'Right Ventricular Outflow Tract': '#001933',
  'Aortic Valve': '#193300',
  'Pulmonary Valve': '#330019',
  'Interatrial Septum': '#003326',
  'Coronary Sinus': '#260033',
  Esophagus: '#331900',
  'Pulmonary Artery': '#003319',
  'Anterolateral Papillary Muscle': '#330000',
  'Posteromedial Papillary Muscle': '#001933',
  'Descending Aorta': '#193300',
  'Right Coronary Cusp': '#330019',
  'Left Coronary Cusp': '#003319',
  'Non-Coronary Cusp': '#260033',
  'Left Pulmonary Artery': '#332600',
  'Right Pulmonary Artery': '#003300',
  Aorta: '#330000',
};

export const getColor = (key: string): string => {
  if (!(key in anatomyColorMap)) {
    anatomyColorMap[key] = generateRandomHexColor();
  }
  return anatomyColorMap[key];
};
